import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content="{metaDescription}" />
      <meta name="keywords" content="Custom Software, Software Development, Wordpress, gatsby, python, react, Small Business, App Development, Marketing, SEO" />
      <meta content="{site.siteMetadata.description}" name="{site.siteMetadata.description}" />
      
      <script src="https://themesbrand.com/lezir/js/jquery.min.js"></script>
      <script src="https://themesbrand.com/lezir/js/bootstrap.bundle.min.js"></script>
      <script src="https://themesbrand.com/lezir/js/scrollspy.min.js"></script>
      <script src="https://themesbrand.com/lezir/js/jquery.easing.min.js"></script>
      <script src="https://themesbrand.com/lezir/js/unicons.js"></script>
      <script src="https://themesbrand.com/lezir/js/app.js"></script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
